var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconVehiclesCard(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "veh\\xEDculos_main",
    "data-name": "veh\\xEDculos main",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_207",
    "data-name": "Rect\\xE1ngulo 207",
    width: 50,
    height: 50,
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_30",
    "data-name": "Rect\\xE1ngulo 30",
    width: 39.999,
    height: 39.158,
    fill: "#85af26"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Enmascarar_grupo_21",
    "data-name": "Enmascarar grupo 21",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_30",
    "data-name": "Grupo 30",
    transform: "translate(5 5.879)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_29",
    "data-name": "Grupo 29",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_43",
    "data-name": "Trazado 43",
    d: "M36.59,16.2v-.063H40V7.326H36.59l0-1.285c0-.94,0-1.881-.011-2.821A3.122,3.122,0,0,0,33.3,0C24.13,0,15.172,0,6.677.005A3.1,3.1,0,0,0,3.425,3.2c-.005.58,0,1.16,0,1.74v2.4H0v8.808H3.411L3.423,28.19q0,.546,0,1.091c0,.738,0,1.476.005,2.213A3.145,3.145,0,0,0,6.681,34.65H6.9v.434c0,.617,0,1.215,0,1.813A2.195,2.195,0,0,0,9.17,39.146c.619.007,1.248.011,1.9.011.6,0,1.219,0,1.862-.009a2.229,2.229,0,0,0,2.311-2.263c.009-.519.007-1.039,0-1.558,0-.216,0-.432,0-.647h9.515v.373c0,.581,0,1.153,0,1.724a2.237,2.237,0,0,0,2.416,2.374c1.073.006,2.146,0,3.219,0h.2A2.237,2.237,0,0,0,33.1,36.712c0-.55,0-1.1,0-1.657v-.4a3.245,3.245,0,0,0,2.4-.815,3.52,3.52,0,0,0,1.088-2.7c-.035-3.548-.025-7.158-.015-10.649q.006-2.148.01-4.3m.033-2.038V9.286c.436,0,.872,0,1.32,0h.05v4.873ZM31.1,35.481c0,.466,0,.932-.006,1.4-.005.3-.12.3-.253.3-1.222.013-2.471.013-3.816,0-.22,0-.252-.114-.254-.224-.013-.626-.011-1.245-.008-1.9q0-.195,0-.391H31.1ZM13.216,37.013c0,.046-.006.169-.22.17-1.557.011-2.747.011-3.858,0-.142,0-.225-.041-.228-.24C8.9,36.322,8.9,35.7,8.9,35.066v-.39h4.324l0,.384c0,.673.008,1.308-.014,1.953m21.356-10.66q0,2.48,0,4.96c0,.95-.428,1.374-1.387,1.375H6.814c-.944,0-1.383-.425-1.384-1.336q0-3.3,0-6.6V22.289H34.571ZM5.473,7.612H18.961V20.264H5.473Zm15.569.016h13.5V20.262h-13.5ZM33.2,1.962c.943,0,1.365.416,1.367,1.348q0,.6,0,1.211V5.6H5.433q0-.262,0-.522c-.006-.72-.011-1.4.013-2.09A1.1,1.1,0,0,1,6.535,1.965c.081,0,.162,0,.265,0h4.8q10.8,0,21.6,0M3.376,14.169H2.01V9.32H3.376Z",
    transform: "translate(0 0)",
    fill: "#85af26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_44",
    "data-name": "Trazado 44",
    d: "M31.675,93.928H31.7a3.292,3.292,0,0,0,3.323-3.2,3.151,3.151,0,0,0-.951-2.284,3.338,3.338,0,0,0-2.346-.982h-.022a3.273,3.273,0,0,0-3.293,3.191,3.189,3.189,0,0,0,.943,2.316,3.3,3.3,0,0,0,2.32.96m-1.262-3.219A1.256,1.256,0,0,1,30.8,89.8a1.309,1.309,0,0,1,.92-.373h.011a1.3,1.3,0,0,1,.909.383,1.245,1.245,0,0,1,.378.9,1.3,1.3,0,0,1-1.3,1.269h-.006a1.284,1.284,0,0,1-1.293-1.264",
    transform: "translate(-20.361 -63.233)",
    fill: "#85af26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_45",
    "data-name": "Trazado 45",
    d: "M92.648,93.926h.075a3.318,3.318,0,0,0,2.285-.894,3.18,3.18,0,0,0,1.012-2.274,3.278,3.278,0,0,0-3.247-3.3,3.333,3.333,0,0,0-2.344.915,3.187,3.187,0,0,0-1.019,2.287,3.277,3.277,0,0,0,3.238,3.264m.059-1.953a1.275,1.275,0,1,1,.019-2.55h.007a1.291,1.291,0,0,1,.9.371,1.244,1.244,0,0,1,.387.894h0a1.269,1.269,0,0,1-.393.92,1.292,1.292,0,0,1-.923.365",
    transform: "translate(-64.074 -63.233)",
    fill: "#85af26"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_29",
    "data-name": "Rect\\xE1ngulo 29",
    width: 7.714,
    height: 1.932,
    transform: "translate(16.143 26.505)",
    fill: "#85af26"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconVehiclesCard);
export default __webpack_public_path__ + "static/media/icon_vehicles_card.fff18b8836bf3b5cb80ad832fa7d8e19.svg";
export { ForwardRef as ReactComponent };